import { UPSCALE_MODEL_TIMEOUT_MS } from '@messenger/consts'

/**
 * Shared numbers and labels for the "Enhance" (AI upscale) flow in the case
 * images grid. Kept in one place so the UI copy, the polling loop, and the
 * tests all agree.
 */

/**
 * Below this long-edge size a case image is flagged as low resolution. The
 * agreed rule is "under 150 effective DPI at the placed size", but the grid
 * has no placed size, so it uses this pixel proxy: a photo whose longest side
 * is under 1200 px prints blurry on the common 8x10 in product at 150 DPI.
 */
export const LOW_RESOLUTION_LONG_EDGE_PX = 1200

/**
 * Total time the Enhancing state waits before giving up: 240 s. It must
 * outlast everything the backend can still do with a generation that will
 * succeed: the worker's model timeout (`UPSCALE_MODEL_TIMEOUT_MS`, 180 s)
 * plus the queue wait before it and the resample, encode and upload after
 * it, which the extra minute covers. A generation at the model's largest
 * size has been measured at about 100 s from start to "Enhancement
 * complete". Giving up sooner would show an error while a paid generation is
 * still running.
 */
export const ENHANCE_TIMEOUT_MS = UPSCALE_MODEL_TIMEOUT_MS + 60_000
